import * as z from "zod";
import {
  hsaReconciliationCsvOutputSchema,
  hsaReconciliationDateSchema,
} from "./hsa-reconciliation-common";

/** Longest payout-date range one export covers, inclusive; every payout in it
 * costs a Gale call. */
export const HSA_PAYOUTS_EXPORT_MAX_DAYS = 93;

/** Payouts one export reads; past this the file is marked truncated. */
export const HSA_PAYOUTS_EXPORT_MAX_PAYOUTS = 200;

/** Every payout with a value date in the range, one row each with its lines'
 * gross, refunds, fees and net. Same access as `getHsaPayouts`. */
export const exportHsaPayoutsCsv = {
  name: "exportHsaPayoutsCsv" as const,
  input: z.object({
    dateFrom: hsaReconciliationDateSchema,
    dateTo: hsaReconciliationDateSchema,
  }),
  output: hsaReconciliationCsvOutputSchema,
};
